// src/ForgotPassword.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL } from '../Config';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Invalid email format.");
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/api/user/forgotPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        toast.success(`Reset link sent to ${email} and Whatsapp!Redirecting to login...`);
        setTimeout(() => {
          navigate("/login");
        }, 4000); // Redirect to login after 3 seconds
        setEmail("");
      } else {
        const data = await response.json();
        toast.error(data.message || "Failed to send reset link.");
      }
    } catch (error) {
      toast.error("Failed to send reset link. Please try again.");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.formBox}>
        <h2 style={styles.header}>Forgot Password</h2>
        <form style={styles.form} onSubmit={handleForgotPassword}>
          <input
            type="email"
            placeholder="Enter your email"
            required
            style={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit" style={styles.button}>Send Reset Link</button>
          <button style={styles.link} onClick={() => navigate('/login')}>
            Back to Login
          </button>
          {error && <p style={styles.error}>{error}</p>}
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f7fa',
    flexDirection: 'column',
  },
  formBox: {
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '40px',
    maxWidth: '400px',
    width: '100%',
  },
  header: {
    fontSize: '1rem',
    marginBottom: '20px',
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    padding: '10px',
    marginBottom: '10px',
    fontSize: '12px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    width: '95%',
  },
  button: {
    padding: '10px',
    fontSize: '12px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#007bff',
    color: 'white',
    cursor: 'pointer',
    width: '100%',
    marginTop: '10px',
  },
  link: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#007bff',
    cursor: 'pointer',
    textDecoration: 'underline',
    marginTop: '10px',
  },
  error: {
    color: 'red',
    marginTop: '10px',
  },
};

export default ForgotPassword;
